import { axiosInstance } from "../../config/axios";
import { AxiosError } from "axios";
import { useMutation } from "react-query";

export type UpdateMerchantIntegratorInformationRequest = {
  merchantId: number;
  integratorId: number;
  integratorUid: string;
  integratorPwd: string;
  integratorGbAlias: string;
  integratorEArchiveGbAlias: string;
};

async function updateMerchantIntegratorInformation(
  data: UpdateMerchantIntegratorInformationRequest
): Promise<any> {
  try {
    return (await axiosInstance.post("/Merchant/UpdateMerchantIntegratorInformation", data)).data;
  } catch (ex) {
    throw ((ex as AxiosError).response?.data as any).error;
  }
}

export function useUpdateMerchantIntegratorInformation() {
  return useMutation<any, Error, UpdateMerchantIntegratorInformationRequest>(
    (variables) => updateMerchantIntegratorInformation(variables)
  );
}
